import { cognotaBackendApi as api } from './api';
import axios from 'axios';

export const deleteUser = async (userId: string) => {
  const response = await api.delete(`members/${userId}`);
  if (axios.isAxiosError(response)) {
    throw response;
  }
  return response.data;
};

export const changeLdUserToBusiness = async (
  userId: string,
  businessTeamId: string
) => {
  const response = await api.patch(`members/${userId}/type`, {
    type: 'business',
    businessTeamId,
  });
  if (axios.isAxiosError(response)) {
    throw response;
  }
  return response.data;
};
